import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { alreadyPaying: Boolean }
  connect() {
    this.trackPurchases()
  }

  trackPurchases() {
    // For the revenue tracking, we use the LTVs. It implies we only track if
    // it's an upgrade from a Free plan.
    if (this.alreadyPayingValue === false) {

      // Google Universal Analytics (UA)
      gtag("event", "purchase", {
        "transaction_id": gon.transaction.id,
        "value": gon.transaction.revenue,
        "currency": "USD",
        "shipping": 0,
        "items": [
          {
            "id": gon.transaction.plan_id,
            "name": gon.transaction.plan_name,
            "quantity": 1,
            "price": gon.transaction.revenue
          }
        ]
      })
      App.analytics.ga_track("Subscription", "Pay")

      // Google Analytics 4 (GA4)
      dataLayer.push({ ecommerce: null })
      dataLayer.push({
        event: "purchase",
        ecommerce: {
          transaction_id: gon.transaction.id,
          value: gon.transaction.revenue,
          currency: "USD",
          items: [
            {
              id: gon.transaction.plan_id,
              name: gon.transaction.plan_name,
              quantity: 1,
              price: gon.transaction.revenue
          }]
        }
      })

      // Google Ads and Facebook Ads are only tracked in production
      if (window.rails_env === "production") {
        // We trigger the event after 5 seconds to be confident the external
        // scripts are loaded
        setTimeout(function() {
          // Facebook tracking
          if (typeof fbq !== "undefined") {
            fbq("track", "Purchase", {
              currency: "USD",
              value: gon.transaction.revenue
            })
          }

          // Google Ads
          if (typeof gtag !== "undefined" && gtag !== null) {
            gtag("event", "conversion", {
                "send_to": gon.google_ads.id + "/" + gon.google_ads.purchase_event_id,
                "value": gon.transaction.revenue,
                "currency": "USD",
                "transaction_id": gon.transaction.id
            })
          }
        }, 5000)
      } else if (window.rails_env === "development") {
        console.info(`Facebook Ads tracked: Purchase of a value ${gon.transaction.revenue} USD`)
        console.info(`Google Ads tracked: Purchase of a value ${gon.transaction.revenue} USD (conversion ID \"${gon.google_ads.purchase_event_id}\")`)
      }
    }
  }
}
